// extracted by mini-css-extract-plugin
module.exports = {"list":"CardSettingsList_list__L_QDd"};